/**
 * ユーティリティ関数集
 */

/**
 * 実行時間をフォーマット
 * - 60秒未満: "X.X秒"（小数点以下1桁）
 * - 60秒以上: "M:SS"（分:秒）
 *
 * @param durationMs 実行時間（ミリ秒）
 * @returns フォーマット済みの文字列
 */
export function formatDuration(durationMs: number): string {
  // 負の値は 0 として扱う
  if (durationMs < 0) {
    return '0.0秒';
  }

  const totalSeconds = durationMs / 1000;

  // 60秒未満は「X.X秒」形式
  if (totalSeconds < 60) {
    return `${totalSeconds.toFixed(1)}秒`;
  }

  // 60秒以上は「M:SS」形式
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = Math.floor(totalSeconds % 60);
  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
}
